module.exports = __webpack_public_path__ + "static/media/spicy_roll.d0953dee.webp";